


export const PRODUCT_TYPE = {
	DRAFT: 1,
	ACTIVE: 2,
	SOLD: 3,
};
